<template>
  <div>
    <masterList
      :tableColumns="tableColumns"
      :module="'rfids'"
      :addNew="addNew"
    ></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    masterList,
  },

  data() {
    return {
       addNew: "/rfids/details/_new",
       tableColumns: [
              {
                prop: 'code',
                label: 'CODE',
                minWidth: 100,
                sortable: true,
                key:'CODE'
              },
              {
                prop: 'c',
                label: 'IS_ASSIGNED',
                minWidth: 100,
                sortable: true,
                key:'IS_ASSIGNED'
              },
              {
                prop: 'remarks',
                label: 'REMARKS',
                sortable: true,
                key:'REMARKS'
              }
        ],

    };
  },
  watch:{
          language_terms: {
            handler(val){
                this.updateTableLang()
            }
        }
  },
  mounted(){
     this.updateTableLang()
  },
  methods:{
    updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    }

  }
};
</script>

<style>
</style>